export default __webpack_public_path__ + "static/media/inner-join.54baaaf8.svg";